import React from 'react';
import { Selection, CheckboxVisibility, DetailsList, DetailsListLayoutMode, SelectionMode, EventGroup, FontIcon, mergeStyles, IDetailsRowProps, Text, IconButton, IIconProps } from '@fluentui/react';
import PecMailItemCell from './PecMailItemCell';
import { IMailPecMail, IPagedMailsRequest } from '../../shared/interfaces';
import { reduxActions, RootState } from '../../store';
import { matchPath, RouteComponentProps, withRouter } from 'react-router-dom';
import pecmailService from '../../services/pecmail.service';
import axios, { CancelTokenSource } from 'axios';
import CircleLoader from '../Loader/CircleLoader/CircleLoader';
import { myTheme } from '../../assets/styles/my-theme';
import { store } from '../..';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect, ConnectedProps } from 'react-redux';


const { palette } = myTheme;

const queryString = require('query-string');

const folderTreePathString = "/:aooId/pecmail/:mailboxAddress";
const mailListItemsPathString = "/:aooId/pecmail/:mailboxAddress/:folderId";
const mailItemViewerPathString = "/:aooId/pecmail/:mailboxAddress/:folderId/:mailId";

const mapState = (state: RootState) => ({
    currentAoo: state.sessionReducer.currentAoo,
})

const mapDispatch = {
}

const connector = connect(mapState, mapDispatch);
type PropsFromRedux = ConnectedProps<typeof connector>

export interface PecMailListItemsProps {
    forceRefresh: boolean

}
type Props = PecMailListItemsProps & PropsFromRedux & RouteComponentProps

export interface PecMailListItemsState {
    loading: boolean
    selectedAooId: string | undefined
    selectedMailboxAddress: string | undefined
    selectedFolderId: number | undefined
    selectedMailId: string | undefined
    mails: Partial<IMailPecMail>[]
    ascendingOrder: boolean
    page: number
}

class PecMailListItems extends React.Component<Props, PecMailListItemsState> {

    constructor(props) {
        super(props);

        this.state = {
            loading: true,
            selectedAooId: undefined,
            selectedMailboxAddress: undefined,
            selectedFolderId: undefined,
            selectedMailId: undefined,
            mails: [],
            ascendingOrder: false,
            page: 1,
        }
    }

    cancelTokenSources = {};
    events = new EventGroup(undefined);

    pecSelection = new Selection({
        onSelectionChanged: () => { }
    });

    componentDidMount() {
        this.events.on(this.pecSelection, 'change', () => {
            const selection = this.pecSelection.getSelection()[0] as IMailPecMail;
            if (selection) {
                store.dispatch(reduxActions.mailProtocolWizardActions
                    .updateMailProtocolWizardState({
                        selectedMail: selection,
                        selectedDocument: undefined
                    }))

                let path = this.getParamsValuesFromUrl() + `/${selection.id}`;
                this.props.history.push({ pathname: path, search: this.props.location.search });
            } else {
                store.dispatch(reduxActions.mailProtocolWizardActions
                    .updateMailProtocolWizardState({
                        selectedMail: undefined,
                        selectedDocument: undefined
                    }))
            }
        });

        this.getParamsValuesFromUrl();

        const { selectedFolderId, selectedMailboxAddress } = this.state;
        const aooId = this.props.match.params["aooId"];
        if (this.state.selectedFolderId !== undefined) {

            // recupero il valore presente nel localStorage per mantenere quello stato al mounting
            const storedAscendingOrder = localStorage.getItem(`ascOrder_${selectedMailboxAddress}_${aooId}_${selectedFolderId}`);

            // Lo riconverto da string a boolean
            const parsedAscendingOrder: boolean = storedAscendingOrder ? JSON.parse(storedAscendingOrder) : false;
            // Aggiorno lo stato
            this.setState({ ascendingOrder: parsedAscendingOrder });
        }
    }
    componentWillUnmount() {

        // cancello tutte le request in pending
        for (const [key, value] of Object.entries<CancelTokenSource>(this.cancelTokenSources)) {
            value.cancel(`${key} canceled`)
        }
        this.events.dispose();

    }

    componentDidUpdate(oldProps: Props, oldState: PecMailListItemsState) {
        const { selectedFolderId, selectedMailboxAddress } = this.state;
        const aooId = this.props.match.params["aooId"];

        if (oldProps.location.pathname !== this.props.location.pathname) {

            this.getParamsValuesFromUrl();
        }

        if (oldState.selectedFolderId !== this.state.selectedFolderId || oldProps.forceRefresh !== this.props.forceRefresh
            || oldState.ascendingOrder !== this.state.ascendingOrder) {
            this.pecSelection.setAllSelected(false);
            store.dispatch(reduxActions.mailProtocolWizardActions
                .updateMailProtocolWizardState({
                    selectedMail: undefined,
                    selectedDocument: undefined
                }))
            this.setState({
                mails: [],
                page: 1,
                //aggiorno il valore al cambio di cartella
                ascendingOrder: JSON.parse(localStorage.getItem(`ascOrder_${selectedMailboxAddress}_${aooId}_${selectedFolderId}`)!)
            }, () => { this.getMailsFromFolder() })

        }
    }


    getParamsValuesFromUrl = () => {
        let path;

        const { location } = this.props;

        // Uso matchPath per prendere i parametri dai path dei component figli

        const matchFolderTreePath = matchPath(location.pathname, {
            path: folderTreePathString,
            exact: true
        })
        if (matchFolderTreePath) {
            this.setState({
                selectedAooId: matchFolderTreePath.params['aooId'],
                selectedMailboxAddress: matchFolderTreePath.params['mailboxAddress'],
                selectedFolderId: undefined,
                selectedMailId: undefined
            })
        }
        const matchMailListItemsPath = matchPath(location.pathname, {
            path: mailListItemsPathString,
            exact: true
        });

        if (matchMailListItemsPath) {
            this.setState({
                selectedAooId: matchMailListItemsPath.params['aooId'],
                selectedMailboxAddress: matchMailListItemsPath.params['mailboxAddress'],
                selectedFolderId: matchMailListItemsPath.params['folderId'],
                selectedMailId: undefined
            })
            path = `/${matchMailListItemsPath.params['aooId']}/pecmail/${matchMailListItemsPath.params['mailboxAddress']}/${matchMailListItemsPath.params['folderId']}`;

        }
        const matchMailItemViewerPathString = matchPath(location.pathname, {
            path: mailItemViewerPathString,
            exact: true
        })
        if (matchMailItemViewerPathString) {
            this.setState({
                selectedAooId: matchMailItemViewerPathString.params['aooId'],
                selectedMailboxAddress: matchMailItemViewerPathString.params['mailboxAddress'],
                selectedFolderId: matchMailItemViewerPathString.params['folderId'],
                selectedMailId: matchMailItemViewerPathString.params['mailId']
            })
            path = `/${matchMailItemViewerPathString.params['aooId']}/pecmail/${matchMailItemViewerPathString.params['mailboxAddress']}/${matchMailItemViewerPathString.params['folderId']}`;
        }

        return path;

    }

    getMailsFromFolder = () => {


        const parsedQueryString = queryString.parse(this.props.location.search);
        let uorId: number | undefined = parsedQueryString.uorId ? Number(parsedQueryString.uorId) : undefined;

        let { selectedAooId, selectedFolderId, selectedMailboxAddress, ascendingOrder, page } = this.state;
        if (selectedAooId && uorId && selectedFolderId && selectedMailboxAddress) {
            this.setState({ loading: true });

            // se in cancelTokenSources c'è il cancelToken associato alla chiamata
            // chiamo il metodo cancel che interrompe la chiamata in pending
            this.cancelTokenSources[pecmailService.getNotRegisteredMailsInFolderAsStream.name]?.cancel("Request annullata");
            // Ricreo il cancel token ad ogni request
            this.cancelTokenSources[pecmailService.getNotRegisteredMailsInFolderAsStream.name] = axios.CancelToken.source();

            //creo mailsRequest
            let pagedMailsRequest: IPagedMailsRequest =
            {
                filtro: "Tutti",
                ascendingOrder: ascendingOrder ?? false,
                folderId: selectedFolderId,
                pageSize: 50,
                page: page,
            }

            pecmailService.getNotRegisteredMailsInFolderAsStream(selectedAooId, uorId, selectedMailboxAddress, pagedMailsRequest, this.cancelTokenSources[pecmailService.getNotRegisteredMailsInFolderAsStream.name].token)
                .then(result => {

                    let currentItems = this.state.mails.slice();

                    let items: any[] = result.items;

                    if (result.hasNextPage) {
                        items.push(null); //aggiungo un item null così DetailsList capisce che deve chiamare il metodo onRenderMissingItem
                    }

                    let newMails = [...currentItems, ...items];

                    this.setState({
                        mails: newMails,
                        loading: false,
                        page: page + 1
                    },
                        () => {

                            if (newMails && newMails.length > 0) {
                                let index = newMails.findIndex(el => el && el.id.toString() === this.state.selectedMailId)
                                if (index >= 0) {
                                    this.pecSelection.setIndexSelected(index, true, false)
                                }
                                else {
                                    this.pecSelection.setAllSelected(false);

                                }
                            }

                        })


                    delete this.cancelTokenSources[pecmailService.getNotRegisteredMailsInFolderAsStream.name];

                })
                .catch(error => {
                    if (axios.isCancel(error)) {
                        //se non metto il catch partono delle chiamate tipo: static/js/vendors~main.chunk.js.map
                        console.log(error.message);
                    } else {
                        this.setState({
                            loading: false
                        })

                        throw error;
                    }
                });
        }

    }

    onSortItemList = () => {
        const { ascendingOrder, selectedFolderId, selectedMailboxAddress } = this.state;
        const aooId = this.props.match.params["aooId"];
        let newAscendingOrder = !ascendingOrder;
        this.setState({ ascendingOrder: newAscendingOrder });
        // salvo il nuovo ordinamento nel local storage
        localStorage.setItem(`ascOrder_${selectedMailboxAddress}_${aooId}_${selectedFolderId}`, JSON.stringify(newAscendingOrder));
    }

    onRenderMissingItem = (index?: number | undefined, rowProps?: IDetailsRowProps | undefined): null => {
        let currentItems = this.state.mails.slice();
        currentItems.pop();
        this.setState({ mails: currentItems }, () => { this.getMailsFromFolder() })

        return null;
    };

    onRenderMailsListRow = (rowProps, defaultRender) => {
        rowProps.onRenderDetailsCheckbox = (defaultRender) => {
            return defaultRender({ ...this.props });
        };

        rowProps.onRenderItemColumn = (item) => {
            return <PecMailItemCell pecMailItem={item} />
        };
        rowProps.styles = {
            root: {
                '&.is-selected': {
                    borderLeft: `2px solid ${palette.themePrimary}`
                }
            },
            cell: { padding: '11px 18px 11px 18px', cursor: 'pointer' }
        };
        return <div>{defaultRender({ ...rowProps })}</div>;
    }

    public render() {
        return (
            <div className='pecmail-layout-list-items-component'>
                <CircleLoader loaderClass='loader-large' loading={this.state.loading} />

                <div style={{ display: 'flex', justifyContent: 'flex-end', borderBottom: '1px solid #eee' }}>

                    <Text style={{ padding: '10px 0px' }} >Data</Text>

                    {this.state.ascendingOrder === true ?
                        <span>
                            <FontAwesomeIcon
                                className='sort-mail-icon'
                                icon={{ prefix: 'far', iconName: 'arrow-up-wide-short' }}
                                onClick={this.onSortItemList} />
                        </span>
                        :
                        <span>
                            <FontAwesomeIcon
                                className='sort-mail-icon'
                                icon={{ prefix: 'far', iconName: 'arrow-down-wide-short' }}
                                onClick={this.onSortItemList} />
                        </span>
                    }

                </div>

                {
                    (this.state.mails && this.state.mails.length > 0) &&
                    <DetailsList
                        items={this.state.mails}
                        columns={[{
                            key: 'mail',
                            fieldName: '',
                            name: '',
                            minWidth: 100,
                        }]}
                        compact={false}
                        isHeaderVisible={false}
                        onRenderRow={this.onRenderMailsListRow}
                        onRenderMissingItem={this.onRenderMissingItem}
                        layoutMode={DetailsListLayoutMode.justified}
                        checkboxVisibility={CheckboxVisibility.hidden}
                        selection={this.pecSelection}
                        selectionPreservedOnEmptyClick={true}
                        selectionMode={SelectionMode.single}

                    />
                }
                {
                    (!this.state.mails || this.state.mails.length == 0) && !this.state.loading &&
                    <div className='empty-folder' >
                        <span>
                            <FontIcon iconName="FabricOpenFolderHorizontal" className={mergeStyles({
                                fontSize: 80,
                                height: 80,
                                width: 80,
                                margin: '0 25px',
                                color: palette.themePrimary
                            })} /></span>
                        <span>Nessun messaggio da visualizzare</span>
                    </div>
                }
            </div >

        )
    };

}
export default connector(withRouter(PecMailListItems));


